import { createTheme } from "@mui/material/styles";
import { alpha } from "@mui/material";
import { commonTransitions,commonTypography } from "./common";

const setDarkTheme = (custom_palette) => {
  const {
    primary: darkPalettePrimaryColor,
    secondary: darkPaletteSecondaryColor,
  } = custom_palette;

  const white = "#fff";

  const darkPalette = {
    primary: {
      main: darkPalettePrimaryColor,
      contrastText: "#fff",
    },
    secondary: {
      main: darkPaletteSecondaryColor,
    },
    background: {
      main: "#111727",
      secondary: "#202938",
    },
    text: {
      main: "rgba(255, 255, 255, 0.7)", // white with opacity
      secondary: darkPalettePrimaryColor, // primary.main
      tertiary: white, // white
    },
  };

  const darkTheme = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            border: `1px solid ${alpha(darkPalettePrimaryColor, 0.2)}`,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            backgroundColor: alpha(darkPalettePrimaryColor, 0.2),
          },
        },
      },
    },

    palette: darkPalette,
    transitions:commonTransitions,
    typography: commonTypography,
  });

  return darkTheme;
};

export default setDarkTheme;
